import {PAGINATION_DEFAULT_LIMIT} from "../../../helpers/constants";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {I18n} from "../../../I18n/components/promoter";
import Pagination from "../../Pagination/Pagination";
import React from "react";

const PromoterSectionList = props => {
    let firstElementNumber = props.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
    const sections = props.sections;
    const tableData = sections.map((section) => {
        const category = props.categories.find(category => category.id === section.categoryId);
        const company = category
            ? props.companies.find(company => company.id === category.companyId)
            : null;
        return {
            count_id: firstElementNumber++,
            id: section.id,
            name: section.name,
            categoryName: category ? category.name : '',
            companyName: company ? company.name : '',
            actions: (
                <div className="text-center">
                    <Button
                        onClick={() => props.onEditSection(section.id)}
                        color="inverse"
                        size="sm"
                        round="true"
                        icon="true"
                    >
                        <i className="fa fa-edit"/>
                    </Button>
                    <Button
                        onClick={() => props.isOkModalToggle(section.id)}
                        className="ml-1"
                        color="danger"
                        size="sm"
                        round="true"
                        icon="true"
                    >
                        <i className="fa fa-times"/>
                    </Button>
                </div>
            )
        };
    });
    return (
        <div className="MyReactTableClass">
            <ReactTable
                getProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            border: "none",
                            padding: "5px 0"
                        }
                    };
                }}
                getTheadProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            boxShadow: "none",
                            padding: "10px 0",
                            fontWeight: "600"
                        }
                    };
                }}
                getTheadThProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none"
                        }
                    };
                }}
                getTdProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none",
                        }
                    };
                }}
                getTrProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            alignItems: "center"
                        }
                    };
                }}
                getNoDataProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            top: "100%"
                        }
                    };
                }}
                columns={[
                    {
                        Header: "#",
                        accessor: "count_id",
                        sortable: false,
                        filterable: false,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        },
                        maxWidth: 100
                    },
                    {
                        Header: `${I18n[props.lang].name}`,
                        accessor: "name",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        style: {
                            textAlign: "left",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].category}`,
                        accessor: "categoryName",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].company}`,
                        accessor: "companyName",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        show: props.companies && props.companies.length !== 1,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: "",
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                        maxWidth: 75
                    }
                ]}
                PaginationComponent={Pagination}
                nextText={">>"}
                previousText={"<<"}
                defaultPageSize={-1}
                pageSize={tableData.length}
                showPaginationBottom={props.totalPages > 1}
                className="-highlight"
                data={tableData}
                filterable
                manual
                onPageChange={props.setCurrentPage}
                page={props.currentPage}
                pages={props.totalPages}
            />
        </div>
    )
};

export default PromoterSectionList;


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterSection/PromoterSectionList.js